import React, { useMemo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

function Top5SkusTable({ data = [], isLive = false, isLoading = false }) {
  // Sort the data by quantity in descending order
  const sortedData = useMemo(() => {
    return [...data].sort((a, b) => b.quantity - a.quantity);
  }, [data]);

  return (
    <TableContainer sx={{ maxHeight: 400 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: 'rgba(0,0,0,0.03)' }}>
            <TableCell>SKU</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell align="center">Qtd</TableCell>
            <TableCell align="right">Faturamento</TableCell>
            <TableCell align="right">Margem</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
                <CircularProgress size={30} />
              </TableCell>
            </TableRow>
          ) : sortedData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
                <Typography variant="body2" color="text.secondary">
                  Nenhum SKU encontrado
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            sortedData.map((row, index) => (
              <TableRow
                key={row.id || index}
                sx={{
                  '&:nth-of-type(odd)': { backgroundColor: 'rgba(0,0,0,0.01)' },
                  transition: 'background-color 0.2s',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                  animation: isLive && row._updated ? 'fadeIn 0.5s ease-out' : 'none'
                }}
              >
                <TableCell component="th" scope="row" sx={{ maxWidth: 120 }}>
                  <Typography noWrap variant="body2" sx={{ fontWeight: 600 }}>
                    {row.id}
                  </Typography>
                </TableCell>
                <TableCell sx={{ maxWidth: 180 }}>
                  <Typography noWrap variant="body2" title={row.name}>
                    {row.name}
                  </Typography>
                </TableCell>
                <TableCell align="center">{row.quantity}</TableCell>
                <TableCell align="right">{row.revenue}</TableCell>
                <TableCell align="right">
                  <Box display="flex" alignItems="center" justifyContent="flex-end">
                    {row.trend === 'up' ? (
                      <TrendingUpIcon fontSize="small" color="success" sx={{ mr: 0.5 }} />
                    ) : row.trend === 'down' ? (
                      <TrendingDownIcon fontSize="small" color="error" sx={{ mr: 0.5 }} />
                    ) : null}
                    {row.margin}
                  </Box>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Top5SkusTable;
